import { ReviewStatus } from "models/IProjectIQWorkspace";

export interface IReviewStatusOption {
  value: ReviewStatus;
  label: string;
}

export const REVIEW_STATUS_OPTIONS: IReviewStatusOption[] = [
  { value: "complete", label: "Complete" },
  { value: "pending", label: "Pending" },
  { value: "not_started", label: "Not Started" },
];

export const NO_TEAM_MEMBERS_MESSAGE =
  "No team members yet — add roles on the People page.";

export const NO_VALUE_PLACEHOLDER = "—";

export const REVIEWER_PLACEHOLDER = "Add reviewer";
